import React from "react";
import PageWrapper from "./components/PageWrapper";

const App = () => {
  return <PageWrapper />;
};

export default App;
